export * from './analytics';
export * from './hooks/useAnalyticsPageView';
export * from './hooks/useAnalyticsContext';
export * from './hooks/useAnalyticsIdentify';
export * from './context/AnalyticsProvider';

declare global {
  interface Window {
    optLayer?: any[];
  }
}
